import { cardItems } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门推荐</h2>
          <p className="text-sm text-foreground-500">精选七部口碑佳作，总有一部让你欲罢不能</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/80 cursor-pointer transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-2 left-2 bg-primary-500/90 text-background-50 text-[10px] font-medium px-2 py-0.5 rounded-full">
                  {item.tag}
                </span>
                <span className="absolute top-2 right-2 bg-background-50/90 text-foreground-700 text-[10px] px-2 py-0.5 rounded-full">
                  {item.category}
                </span>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}